import '../css/layoutView.scss';
import '../css/layoutBulkDownload.scss';
import '../css/storeChangeBatch.scss';
import { getHtml } from "../apis/templateHtml";
import { initializeHeader } from './header';
/**
 * モック画面用の汎用初期化関数
 * @param htmlPath HTMLファイルのパス
 * @param title ページタイトル
 */
export const initializeMockPage = async (htmlPath, title) => {
    console.log(`=== initializeMockPage 開始: ${title} ===`);
    try {
        // HTMLテンプレートを取得
        const content = await getHtml(htmlPath);
        const subContents = document.getElementById('subContents');
        if (content && subContents) {
            subContents.innerHTML = content;
            // ヘッダーを初期化
            initializeHeader(title);
        }
        console.log(`=== initializeMockPage 完了: ${title} ===`);
    }
    catch (error) {
        console.error(`モック画面の初期化でエラーが発生しました (${title}):`, error);
    }
};
